export const loadScript = url => {
  const script = document.createElement('script');
  script.src = url;
  script.async = true;

  document.head.appendChild(script);
};



// WEBPACK FOOTER //
// ./src/utils/loadScript.js